import { render, staticRenderFns } from "./FormCreate.vue?vue&type=template&id=62f89818&scoped=true"
import script from "./FormCreate.vue?vue&type=script&lang=js"
export * from "./FormCreate.vue?vue&type=script&lang=js"
import style0 from "./FormCreate.vue?vue&type=style&index=0&id=62f89818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f89818",
  null
  
)

export default component.exports